import { render, staticRenderFns } from "./footBottom.vue?vue&type=template&id=040f5a2f&scoped=true"
import script from "./footBottom.vue?vue&type=script&lang=js"
export * from "./footBottom.vue?vue&type=script&lang=js"
import style0 from "./footBottom.vue?vue&type=style&index=0&id=040f5a2f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040f5a2f",
  null
  
)

export default component.exports